import { render, staticRenderFns } from "./ViewPreviousOrder.vue?vue&type=template&id=4c09b29c&scoped=true&"
import script from "./ViewPreviousOrder.vue?vue&type=script&lang=js&"
export * from "./ViewPreviousOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c09b29c",
  null
  
)

export default component.exports